import { configure } from 'mobx'
import React from 'react'
import { render } from 'react-dom'
import lang from './stores/lang'
import patient from './stores/patient'
import App from './App'

window.lang = lang
window.patient = patient
configure({ enforceActions: true })
render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js